<template>
  <div
    style="
      font-weight: 600;
      font-size: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    "
  >
    欢迎使用远创劳务系统
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  setup() {
    const state = reactive({});
    onMounted(() => {});
    return { state };
  },
};
</script>
<style scoped></style>
